import dayjs from "dayjs";
import { AppointmentStatus, type Appointment } from "@rmh/defs";
import { sortAppointments } from "./sortAppointments";
import { DateTime } from "luxon";

export const getUpcomingAppointments = (appointments: Appointment[] = []) => {
  // (IL): Appointment on and after today is considered upcoming appointments
  const upcomingAppointments = appointments.filter((appointment) => {
    if (
      DateTime.fromISO(appointment.appointmentDate)
        .diff(DateTime.now().startOf("day"))
        .toMillis() < 0
    ) {
      return false;
    }

    return [
      AppointmentStatus.Scheduled,
      AppointmentStatus.Confirmed,
      AppointmentStatus.Ready,
    ].includes(appointment.appointmentStatus);
  });

  const sortedAppointments = sortAppointments(upcomingAppointments);
  return sortedAppointments;
};

export const getFirstUpcomingAppointments = (
  appointments: Appointment[] = []
) => {
  const upcomingAppointments = getUpcomingAppointments(appointments);
  const sortedAppointments = sortAppointments(upcomingAppointments);

  if (sortedAppointments.length > 0) {
    return sortedAppointments[0];
  }

  return null;
};

export const getCompletedAppointments = (appointments: Appointment[] = []) => {
  return appointments.filter((appointment) =>
    dayjs(appointment.appointmentDate).isBefore(dayjs())
  );
};

export const getLastCompletedAppointment = (
  appointments: Appointment[] = []
) => {
  const completedAppointments = appointments.filter(
    (appointment) =>
      appointment.appointmentStatus === AppointmentStatus.Completed
  );
  const sortedAppointments = sortAppointments(completedAppointments);

  if (sortedAppointments.length === 0) {
    return null;
  }

  return sortedAppointments[sortedAppointments.length - 1];
};

export const getPastAppointments = (appointments: Appointment[] = []) => {
  return appointments.filter((appointment) => {
    const duration = appointment.duration ?? 0;

    return dayjs().isAfter(
      dayjs(appointment.appointmentDate).add(duration, "minute")
    );
  });
};
